import React, { useContext } from "react";

// import context
import { PrivateContext } from "lib/context";

// import constant
import constant from "lib/constant/constant";

// import helpers
import { storageHelper } from "lib/helpers";

// import hoc
import { withFeature, withErrorBoundary } from "lib/hoc";

// import components
import { SkeletonAnnotated } from "lib/components";
import { OperatorSchedulePaymentSetting } from "app/payments/modules/operator/features";

const { userKey } = constant;
const { operator } = userKey;

const SchedulePayment = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === operator) {
      return <OperatorSchedulePaymentSetting />;
    }
    return null;
  };

  const currentUserRole = storageHelper.get("userRole");
  const SchedulePaymentSettingComponent = getComponent(currentUserRole);
  return SchedulePaymentSettingComponent;
};

export default withFeature(withErrorBoundary(SchedulePayment), { feature: constant.SCHEDULE_PAYMENT_SETTING });
